/** @format */

const APP = 'galabid-presenter';

export const AppRoutes = {
    APP,
};
